export const CURRENCY_CODE_MAX_LENGTH = 3;
export const currencyCodeValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('currencies.validation.currency-code-empty');
    } else if (input.length > CURRENCY_CODE_MAX_LENGTH) {
        err = t('currencies.validation.currency-code-too-long', { maxLength: CURRENCY_CODE_MAX_LENGTH });
    } else if (!input.match(/^[a-zA-Z]*$/)) {
        err = t('currencies.validation.currency-code-only-letters');
    }
    return err;
};

export const CURRENCY_NAME_MAX_LENGTH = 128;
export const currencyNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('currencies.validation.currency-name-empty');
    } else if (input.length > CURRENCY_NAME_MAX_LENGTH) {
        err = t('currencies.validation.currency-name-too-long', { maxLength: CURRENCY_NAME_MAX_LENGTH });
    }
    return err;
};

export const currencyExchangeRateValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('currencies.validation.currency-exchange-rate-empty');
    } else if (!input.match(/^\d+(\.\d{1,4})?$/)) {
        err = t('currencies.validation.currency-exchange-invalid-number');
    }
    return err;
};
